import { l } from '@manychat/manyui'

import { AiImproverGoal } from 'apps/aiTextImprover/lib/types'

import { Goal, OptionType } from './types'

export const Goals: Goal[] = [
  {
    value: AiImproverGoal.MAKE_MORE_MARKETING,
    config: {
      type: OptionType.BUTTON,
      label: l.makeTranslate('Style it for marketing'),
      keyCode: '1',
      icon: 'MagicWand',
    },
  },
  {
    value: AiImproverGoal.FRIENDLY,
    config: {
      type: OptionType.BUTTON,
      label: l.makeTranslate('Rewrite it friendly'),
      keyCode: '2',
      icon: 'Smile',
    },
  },
  {
    value: AiImproverGoal.SIMPLIFY,
    config: {
      type: OptionType.BUTTON,
      label: l.makeTranslate('Simplify language'),
      keyCode: '3',
      icon: 'Help',
    },
  },
  {
    value: AiImproverGoal.MORE_ENGAGING,
    config: {
      type: OptionType.BUTTON,
      label: l.makeTranslate('Make more engaging'),
      keyCode: '4',
      icon: 'IncreaseEngagement',
    },
  },
  {
    value: AiImproverGoal.CUSTOM,
    config: {
      type: OptionType.INPUT,
      label: l.makeTranslate('Enter custom task...'),
      keyCode: '5',
      validation: {
        min: 5,
        max: 150,
      },
    },
  },
]
